export {default as CostOfLivingWidget} from "./CostOfLiving"
export {default as RecognitionWidget} from "./Recognition"
export {default as CompanyBenefitsWidget} from "./CompanyBenefits"
export {default as HighestSavingPerksWidget} from "./HighestSavingPerks"
export {default as ValuesCelebrationsWidget} from "./ValuesAndCelebrations"
export {default as WellnessWidget} from "./Wellness"
export const FLEXI_PERK = "flexi_perk"
export const REWARD = "reward"
